export interface INavbarCallLink {
  label: string;
  href: string;
}

export interface INavbarCallLinkConfig {
  callLabel?: string;
  callUrl?: string;
  callPdfLabel?: string;
  callPdfUrl?: string;
}

export const DEFAULT_CALL_LABEL =
  "Call: Andes Virus & ANDV-relevant Hantavirus Research";
export const DEFAULT_CALL_PDF_LABEL = "Download the full call";

function isBlank(value?: string) {
  return typeof value !== "string" || value.trim() === "";
}

function callLink(label: string, href: string): INavbarCallLink {
  return { label: label.trim(), href: href.trim() };
}

/**
 * Builds the navbar links pointing at the current call on isidore-project.eu:
 * the call page, then the full call document.
 *
 * The call changes every funding round - hence configuration rather than
 * constants. Clearing a URL hides its link, which is how the navbar is left
 * without a call between rounds. A blank label falls back to the default, so
 * clearing only the label cannot produce an unlabelled link.
 *
 * These are rendered by NavbarCallLinks.vue and teleported into the navbar
 * rather than handed to the vendored menu through `menuItems`: that menu
 * rewrites every href to `/<schema>/<href>`, which mangles an absolute URL
 * into `/<schema>/https://isidore-project.eu/...`. See App.vue.
 */
export function buildCallLinks(
  config: INavbarCallLinkConfig
): INavbarCallLink[] {
  const links: INavbarCallLink[] = [];

  if (!isBlank(config.callUrl)) {
    const label = isBlank(config.callLabel)
      ? DEFAULT_CALL_LABEL
      : (config.callLabel as string);
    links.push(callLink(label, config.callUrl as string));
  }

  if (!isBlank(config.callPdfUrl)) {
    const label = isBlank(config.callPdfLabel)
      ? DEFAULT_CALL_PDF_LABEL
      : (config.callPdfLabel as string);
    links.push(callLink(label, config.callPdfUrl as string));
  }

  return links;
}
